


















































import Vue from 'vue';

export default Vue.extend({
  name: 'HMAttachmentPreview',
  props: {
    data: {
      type: Object,
      required: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
});
